export interface DomEventService {
  on(target: EventTarget, event: string, handler: EventListenerOrEventListenerObject, options?: AddEventListenerOptions | boolean): void;

  /** `removeEventListener` may need the same options bag as `addEventListener` (e.g. `{ capture, passive }`). */
  off(target: EventTarget, event: string, handler: EventListenerOrEventListenerObject, options?: AddEventListenerOptions | EventListenerOptions | boolean): void;

  once(target: EventTarget, event: string, handler: EventListenerOrEventListenerObject, options?: AddEventListenerOptions | boolean): void;
}

export class BrowserDomEventService implements DomEventService {
  on(
    target: EventTarget,
    event: string,
    handler: EventListenerOrEventListenerObject,
    options?: AddEventListenerOptions | boolean
  ): void {
    target.addEventListener(event, handler, options);
  }

  off(
    target: EventTarget,
    event: string,
    handler: EventListenerOrEventListenerObject,
    options?: EventListenerOptions | boolean
  ): void {
    target.removeEventListener(event, handler, options);
  }

  once(
    target: EventTarget,
    event: string,
    handler: EventListenerOrEventListenerObject,
    options?: AddEventListenerOptions | boolean
  ): void {
    const addOptions =
      typeof options === 'boolean'
        ? { capture: options, once: true as const }
        : { ...(typeof options === 'object' && options !== null ? options : {}), once: true as const };
    target.addEventListener(event, handler, addOptions);
  }
}
